import { savedCartService } from '../../services';

export async function savedCartJobHandler() {
    const isOnline = navigator.onLine;

    if (!isOnline) {
        return;
    }

    const savedCartsToSync = await savedCartService.getCarts();

    const syncPromises = savedCartsToSync.map(async (cart) =>
        savedCartService.syncCarts(cart),
    );

    await Promise.allSettled(syncPromises);
}
